module.exports = __webpack_public_path__ + "img/weisheng.661fe5b0.jpg";